import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SubmitService {

  messageText: string;
  messageType: string;

  constructor() {
    this.messageText = '';
    this.messageType = '';
  }

  setMessage(message: string): void {
    this.messageType = message;
  }

  getMessage(): string {
    return this.messageType;
  }

  setMessageText(message: string): void {
    this.messageText = message;
  }

  getMessageText(): string {
    return this.messageText;
  }
}
